"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountVisitInfoSchema = void 0;
const zod_1 = require("zod");
exports.AccountVisitInfoSchema = zod_1.z.object({
  /** Имеется подписка на пользователя */
  is_subscribed: zod_1.z.boolean(),
  /** Добавлен в друзья */
  is_friend: zod_1.z.boolean()
});
